import classNames from "classnames";

const Pagination = ({ pagination, handlePageChange, loading }) => {
  const generatePageLinks = () => {
    const pageLinks = [];
    const startPage = Math.max(1, pagination.currentPage - 2);
    const endPage = Math.min(pagination.totalPages, pagination.currentPage + 2);

    for (let i = startPage; i <= endPage; i++) {
      pageLinks.push(i);
    }

    return pageLinks;
  };

  return (
    <div className="flex items-center justify-between p-4">
      <div className="text-sm text-gray-700">
        Showing {pagination.currentPage} of {pagination.totalPages} pages
      </div>
      <nav>
        <ul className="inline-flex -space-x-px">
          <li>
            <button
              onClick={() => handlePageChange(1)}
              disabled={loading || pagination.currentPage === 1}
              className={classNames(
                "px-3 py-2 text-sm leading-tight text-gray-500 bg-white border border-gray-300 rounded-l-lg hover:bg-gray-100 hover:text-gray-700",
                {
                  "cursor-not-allowed bg-gray-300 opacity-50":
                    loading || pagination.currentPage === 1,
                }
              )}
            >
              First
            </button>
          </li>
          <li>
            <button
              onClick={() => handlePageChange(pagination.currentPage - 1)}
              disabled={pagination.currentPage === 1 || loading}
              className={classNames(
                "px-3 py-2 text-sm leading-tight text-gray-500 bg-white border border-gray-300 hover:bg-gray-100 hover:text-gray-700",
                {
                  "cursor-not-allowed bg-gray-300 opacity-50":
                    loading || pagination.currentPage === 1,
                }
              )}
            >
              Prev
            </button>
          </li>
          {generatePageLinks().map((pageNumber) => (
            <li key={pageNumber}>
              <button
                onClick={() =>
                  pagination.currentPage !== pageNumber &&
                  handlePageChange(pageNumber)
                }
                disabled={loading}
                className={classNames(
                  "px-3 py-2 text-sm leading-tight border border-gray-300",
                  {
                    "bg-black text-white hover:bg-black hover:text-white-700":
                      pagination.currentPage === pageNumber,
                    "bg-white text-gray-500 hover:bg-gray-100 hover:text-gray-700":
                      pagination.currentPage !== pageNumber,
                    "cursor-not-allowed opacity-50": loading,
                  }
                )}
              >
                {pageNumber}
              </button>
            </li>
          ))}
          <li>
            <button
              onClick={() => handlePageChange(pagination.currentPage + 1)}
              disabled={
                pagination.currentPage === pagination.totalPages || loading
              }
              className={classNames(
                "px-3 py-2 text-sm leading-tight text-gray-500 bg-white border border-gray-300 hover:bg-gray-100 hover:text-gray-700",
                {
                  "cursor-not-allowed bg-gray-300 opacity-50":
                    loading || pagination.currentPage === pagination.totalPages,
                }
              )}
            >
              Next
            </button>
          </li>
          <li>
            <button
              onClick={() => handlePageChange(pagination.totalPages)}
              disabled={
                loading || pagination.currentPage === pagination.totalPages
              }
              className={classNames(
                "px-3 py-2 text-sm leading-tight text-gray-500 bg-white border border-gray-300 rounded-r-lg hover:bg-gray-100 hover:text-gray-700",
                {
                  "cursor-not-allowed bg-gray-300 opacity-50":
                    loading || pagination.currentPage === pagination.totalPages,
                }
              )}
            >
              Last
            </button>
          </li>
        </ul>
      </nav>
    </div>
  );
};

export default Pagination;
